import SidebarWithHeaderTemplate from './SidebarWithHeaderTemplate'

export default SidebarWithHeaderTemplate
